import { render, staticRenderFns } from "./stockInFile.vue?vue&type=template&id=5556f589&scoped=true&"
import script from "./stockInFile.vue?vue&type=script&lang=js&"
export * from "./stockInFile.vue?vue&type=script&lang=js&"
import style0 from "./stockInFile.vue?vue&type=style&index=0&id=5556f589&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5556f589",
  null
  
)

export default component.exports